export class ItfPago {
  constructor(
    public id: number,
    public itfDatabaseId: number,
    public anio: number,
    public fechaPago: string,
    public monto: number,
    public metodoPago?: string | null,
    public notas?: string | null,
    public registradoPor?: number | null,
    public createdAt?: string,
    
    // Relations
    public registrador?: {
      id: number;
      username: string;
    } | null
  ) {}

  static fromApiData(data: any): ItfPago {
    return new ItfPago(
      data.id,
      data.itfDatabaseId || data.itf_database_id,
      data.anio,
      data.fechaPago || data.fecha_pago,
      data.monto,
      data.metodoPago || data.metodo_pago,
      data.notas,
      data.registradoPor || data.registrado_por,
      data.createdAt || data.created_at,
      data.registrador || null
    );
  }

  toJSON() {
    return {
      itfDatabaseId: this.itfDatabaseId,
      anio: this.anio,
      fechaPago: this.fechaPago,
      monto: this.monto,
      metodoPago: this.metodoPago,
      notas: this.notas
    };
  }
}